import { render, staticRenderFns } from "./upFileInquire.vue?vue&type=template&id=756b55cc&scoped=true"
import script from "./upFileInquire.vue?vue&type=script&lang=js"
export * from "./upFileInquire.vue?vue&type=script&lang=js"
import style0 from "./upFileInquire.vue?vue&type=style&index=0&id=756b55cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "756b55cc",
  null
  
)

export default component.exports